export default {
  "navbar": {
    "home": "Home",
    "region": "The Region",
    "territory": "Territory and Coffee",
    "governance": "Governance",
    "news": "News",
    "contact": "Contact",
    "associates": "Members"
  }
}
